import React from "react";
import { twMerge } from "tailwind-merge";
import { useAppSelector } from "store/hooks";
import { userSettingState } from "store/selectors";

// function Headings() {
//   return <></>;
// }

function LevelOne({
  children,
  classes,
}: React.PropsWithChildren<{ classes?: string }>) {
  const { isDarkMode } = useAppSelector(userSettingState);
  return (
    <h1
      className={twMerge(
        `text-white text-center tracking-[1px] text-3xl mb-6 font-serif ${classes} ${
          isDarkMode ? "text-secondary" : ""
        }`
      )}
    >
      {children}
    </h1>
  );
}

function LevelTwo({
  children,
  classes,
}: React.PropsWithChildren<{ classes?: string }>) {
  const { isDarkMode } = useAppSelector(userSettingState);
  return (
    <h2
      className={twMerge(
        `text-white text-center tracking-[1px] text-2xl mb-4 font-serif ${classes} ${
          isDarkMode ? "text-secondary" : ""
        }`
      )}
    >
      {children}
    </h2>
  );
}

function LevelThree({
  children,
  classes,
}: React.PropsWithChildren<{ classes?: string }>) {
  const { isDarkMode } = useAppSelector(userSettingState);
  return (
    <h3
      className={twMerge(
        `text-white text-center tracking-[1px] text-xl mb-3 font-serif ${classes} ${
          isDarkMode ? "text-secondary" : ""
        }`
      )}
    >
      {children}
    </h3>
  );
}

function LevelFour({
  children,
  classes,
}: React.PropsWithChildren<{ classes?: string }>) {
  const { isDarkMode } = useAppSelector(userSettingState);
  return (
    <h4
      className={twMerge(
        `text-white text-center tracking-[1px] text-lg mb-3 font-serif ${classes} ${
          isDarkMode ? "text-secondary" : ""
        }`
      )}
    >
      {children}
    </h4>
  );
}

// Headings.LevelOne = LevelOne;
// export { Headings };

export const Headings = {
  LevelOne,
  LevelTwo,
  LevelThree,
  LevelFour,
};
